import Icon from '../components/Icon.vue'

Icon.register({
  cut: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M278.1 256l166.4 166.4c4.7 4.7 4.7 12.3 0 17-32.8 32.8-86 32.8-118.8 0l-115.5-115.5-24.9 24.9c4.3 10.9 6.7 22.8 6.7 35.3 0 53-43 96-96 96s-96-43-96-96 43-96 96-96c4.5 0 9 0.3 13.4 0.9l32.9-32.9-32.9-32.9c-4.4 0.6-8.8 0.9-13.4 0.9-53 0-96-43-96-96s43-96 96-96 96 43 96 96c0 12.5-2.4 24.3-6.7 35.3l24.9 24.9 115.5-115.5c32.8-32.8 86-32.8 118.8 0 4.7 4.7 4.7 12.3 0 17zM96 160c17.6 0 32-14.4 32-32s-14.4-32-32-32-32 14.4-32 32 14.4 32 32 32zM96 416c17.6 0 32-14.4 32-32s-14.4-32-32-32-32 14.4-32 32 14.4 32 32 32z'
      }
    ]
  }
})
